import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBasketItem } from "../../lib/typings/basket";
import type { RootState } from "../store";

export interface IBasketState {
  items: Array<IBasketItem>;
  delayed: Array<IBasketItem>;
}

const initialState: IBasketState = {
  items: [],
  delayed: [],
};

export const basketSlice = createSlice({
  name: "basket",
  initialState,
  reducers: {
    setBasket: (state, action: PayloadAction<IBasketState>) => {
      state.items = action.payload.items;
      state.delayed = action.payload.delayed;
    },
    clearBasket: (state) => {
      state.items = [];
    },
    clearFavourites: (state) => {
      state.delayed = [];
    },
    setBasketItemQuantity: (state, action: PayloadAction<{ id: string, quantity: number }>) => {
      const itemIndex = state.items.findIndex(item => item.ID === action.payload.id);
      if (itemIndex !== -1) {
        if (state.items[itemIndex].QUANTITY !== action.payload.quantity) {
          state.items[itemIndex].QUANTITY = action.payload.quantity;
        }
      }
    },
    removeBasketItem: (state, action: PayloadAction<{ id: string }>) => {
      const itemIndex = state.items.findIndex(item => item.ID === action.payload.id);
      if (itemIndex !== -1) {
        state.items.splice(itemIndex, 1);
      }
    },
    removeFavouriteItem: (state, action: PayloadAction<{ id: string }>) => {
      const itemIndex = state.delayed.findIndex(item => item.PRODUCT_ID === action.payload.id);
      if (itemIndex !== -1) {
        state.delayed.splice(itemIndex, 1);
      }
    },
    addFavouriteItem: (state, action: PayloadAction<{ item: IBasketItem }>) => {
      const addItem: IBasketItem = { ...action.payload.item, QUANTITY: 1, DELAY: "Y" };
      const itemIndex = state.delayed.findIndex(item => item.ID === action.payload.item.ID);
      if (itemIndex === -1) {
        state.delayed.push(addItem);
      }
    },
    addBasketItem: (state, action: PayloadAction<{ item: IBasketItem }>) => {
      const addItem: IBasketItem = { ...action.payload.item, DELAY: "N" };
      const itemIndex = state.items.findIndex(item => item.ID === action.payload.item.ID);
      if (itemIndex === -1) {
        state.items.push(addItem);
      }
    },
  },
});

export const {
  setBasket,
  clearBasket,
  clearFavourites,
  setBasketItemQuantity,
  removeBasketItem,
  removeFavouriteItem,
  addFavouriteItem,
  addBasketItem,
} = basketSlice.actions;

export const selectBasket = (state: RootState) => state.basket.items;

export default basketSlice.reducer;
